export default __webpack_public_path__ + "static/media/scratch-half-2.c302f933.png";